import { getNodeType, InputRule, isNodeActive } from '@tiptap/core';
import type { DOMOutputSpec } from '@tiptap/pm/model';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { createRicosNodeExtension, withBreakoutContainer } from './../../plugin-commons';

import { createListInputRuleHandler } from '../list-input-rule-handler';
import styles from '../statics/styles-scss';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    bulletList: {
      /**
       * Toggle a bullet list
       */
      toggleBulletList: () => ReturnType;
      /**
       * Toggle off an bulleted list if exists
       */
      toggleOffBulletList: () => ReturnType;
    };
  }
}

const inputRegex = /^\s*([-+*])\s$/;

export const bulletedList = createRicosNodeExtension<{
  HTMLAttributes: Record<string, string>;
  itemTypeName: string;
}>({
  groups: ['no-trailing-node'],
  type: 'html-node',
  name: Node_Type.BULLETED_LIST,
  createExtensionConfig({ mergeAttributes }) {
    return {
      name: this.name,
      addOptions() {
        return {
          HTMLAttributes: { class: styles.bulletedList },
          itemTypeName: Node_Type.LIST_ITEM,
        };
      },

      group:
        'block listItemSecondChildContent layoutCellContent collapsibleListItemTitleContent collapsibleListItemBodyContent tableCellContent',

      content() {
        return 'LIST_ITEM+';
      },

      parseHTML() {
        return [{ tag: 'ul' }];
      },

      addAttributes() {
        return {
          indentation: {
            default: 0,
          },
          offset: {
            default: 0,
          },
        };
      },

      renderHTML({ HTMLAttributes }) {
        return withBreakoutContainer([
          'ul',
          mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
          0,
        ]) as DOMOutputSpec;
      },

      addCommands() {
        return {
          toggleBulletList:
            () =>
            ({ commands }) => {
              return commands.toggleLists(this.name, Node_Type.LIST_ITEM);
            },
          toggleOffBulletList:
            () =>
            ({ state, commands }) => {
              const isActive = isNodeActive(state, getNodeType(this.name, state.schema));
              if (isActive) {
                return commands.toggleBulletList();
              }
              return true;
            },
        };
      },

      addKeyboardShortcuts() {
        return {
          'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
        };
      },

      addInputRules() {
        return [
          new InputRule({
            find: inputRegex,
            handler: createListInputRuleHandler({ type: this.type }),
          }),
        ];
      },
    };
  },
});
